import React from 'react';
import './Music.css';
const Music = () => <section className="music-page-shell" />;

export default Music;
